<!-- 操作面板 -->
<template>
    <div v-if="componentsData.type == 30">
        <div
            class="status-panel bg-div"
            :style="{
                ...(componentsData.content.bg_color && {
                    backgroundColor: componentsData.content.bg_color,
                }),
                ...(componentsData.content.bg_img &&
                    componentsData.content.bg_img.picview &&
                    componentsData.content.bg_value && {
                        backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                    }),
                padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
            }"
        >
            <div v-if="componentsData.content.style_value == '1'">
                <div class="control-title">操作人口</div>
                <div
                    class="control-grid"
                    v-for="(item, index) in componentsData.content.statusList"
                    :key="index"
                >
                    <div>
                        <div class="control-name">
                            {{ item.title || "主标题" }}
                        </div>
                        <div>副标题</div>
                    </div>
                    <Button class="theme-bc theme-default-color"
                        >按钮名称</Button
                    >
                </div>
            </div>
            <div v-else>
                <img src="@/assets/control-2.png" class="w1" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: () => ({}),
            required: true,
        },
    },
    methods: {},
};
</script>

<style scoped>
.status-panel {
    overflow: hidden;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.control-title {
    font-size: 15px;
    color: #000;
    font-weight: bold;
}
.control-grid {
    margin-top: 6px;
    padding: 12px;
    background-color: #f2f7fa;
    border-radius: 5px;
    font-size: 13px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.control-name {
    margin-bottom: 6px;
    font-size: 15px;
    color: #000;
}
.w1 {
    width: 100%;
}
</style>
